<div class="container-scroller" style="display:flex;flex-direction:column;height:100vh;">
    <div class="horizontal-menu" style="position: relative;z-index: unset;">
        <app-header></app-header>
        <app-header2></app-header2>
    </div>
    <div class="container-fluid page-body-wrapper" style="min-height: unset;overflow: auto;flex-grow: 1;">
        <div class="main-panel">
            <div class="content-wrapper">
                <app-breadcrumb></app-breadcrumb>
                <router-outlet></router-outlet>
                <notifier-container></notifier-container>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>
